import Alert, { AlertVariant } from "@galaxy-io/dls/feedback/Alert";
import Flex, { AlignItems, FlexDirection, JustifyContent } from "@galaxy-io/dls/layout/Flex";
import type { Icon as PhosphorIcon } from "@phosphor-icons/react";
import type { ReactNode } from "react";

export function ErrorLayout({
  icon,
  header,
  message,
  error,
  actions,
}: {
  icon?: PhosphorIcon;
  header?: string;
  message?: string;
  error?: Error;
  actions?: ReactNode;
}) {
  return (
    <Flex
      fillWidth
      grow={1}
      direction={FlexDirection.COLUMN}
      alignItems={AlignItems.CENTER}
      justifyContent={JustifyContent.CENTER}
      padding={24}
    >
      <Flex direction={FlexDirection.COLUMN} width="100%" maxWidth={560}>
        <Alert
          variant={AlertVariant.ERROR}
          icon={icon}
          header={header || "Could not load this content"}
          actions={actions}
        >
          {message ||
            error?.message ||
            "Try again. If the problem continues, contact your workspace administrator."}
        </Alert>
      </Flex>
    </Flex>
  );
}
